module.exports = __webpack_public_path__ + "static/img/base_6.9456ebd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/base_6.jpg
// module id = L6Y3
// module chunks = 1